module.exports = __webpack_public_path__ + "static/media/sohini.748e8a30.png";